export function criarLinkWhatsapp(telefone: string | null, texto: string): string | null {
  const digitos = telefone?.replace(/\D/g, '') ?? '';
  if (!digitos) {
    return null;
  }

  const numero = digitos.length === 10 || digitos.length === 11 ? `55${digitos}` : digitos;
  return `https://wa.me/${numero}?text=${encodeURIComponent(texto)}`;
}
